module.exports = __webpack_public_path__ + "static/media/comments-empty-state.0193fcf7.svg";